export default __webpack_public_path__ + "static/media/logo-datacount.029a22e5.png";